<template>
  <div class="mainLayout">
    <div id="mapLayout" class="mapLayout">
      <TheMap :geoJSONCollection="filteredFeatures" />
    </div>

    <TheMetadataUI
      style="position: absolute; top: 64px"
      :filterPropertyKeys="filterPropertyKeys"
      :filterMap="filterMap"
      @filterChange="catchFilterChange"
    />
  </div>

  <div class="legend">
    <ul>
      <li><span class="legend-plants"></span> plant</li>
      <li><span class="legend-protists"></span> protista</li>
      <li><span class="legend-vertebrates"></span> vertebrate</li>
      <li><span class="legend-invertebrates"></span> invertebrate</li>
      <li><span class="legend-fungi"></span> fungi</li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TheMap from '../components/TheMap.vue'
import TheMetadataUI from '@/components/TheMetadataUI.vue'
import { useMetadataStore } from '@/stores/metadataStore'

export default defineComponent({
  components: {
    TheMap,
    TheMetadataUI
  },
  computed: {
    filterMap() {
      const mStore = useMetadataStore()
      return mStore.filterMap
    },
    filterPropertyKeys() {
      const mStore = useMetadataStore()
      return mStore.filterPropertyKeys
    },
    filteredFeatures() {
      const mStore = useMetadataStore()
      return mStore.filteredFeatures
    }
  },
  methods: {
    catchFilterChange(filterItem: ActiveFilterItem) {
      const mStore = useMetadataStore()
      mStore.changeFilter(filterItem)

      // console.log(mStore.filteredMetadata.length);
    }
  },
})
</script>

<style>
.mainLayout {
  /*    display: grid;
    grid-template-rows: 3fr 1fr;*/
  width: 100%;
  height: 100%;
}

.mapLayout {
  display: grid;
  width: 100%;
  height: 100%;
  background-color: transparent;
}
.legend {
  position: fixed; /* Change from absolute to fixed */
  bottom: 0;
  right: 0;
  background: rgba(255, 255, 255, 1);
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px 0;
}

.legend h3 {
  margin-top: 0;
}
.legend ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.legend ul li {
  margin-bottom: 5px;
  font-size: 13px;
}
.legend span {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 5px;
  border: 1px solid #333;
  border-radius: 50%;
}
.legend-plants {
  background: #537a29;
} /* Brighter green */
.legend-protists {
  background: #219ebc;
} /* This blue is generally okay */
.legend-vertebrates {
  background: #ffbf1f;
} /* Distinct golden yellow */
.legend-invertebrates {
  background: #c1121f;
} /* Darker red */
.legend-fungi {
  background: #023047;
} /* Indigo to avoid confusion with dark blues/blacks */
</style>
